// Auto-generated by scripts/split_ui.js from data/recommendedApps.js — do not edit.
export const APPS_UI = {
  "pageTitle": {
    "id": "Aplikasi Pendamping",
    "en": "Companion Apps",
    "ar": "تطبيقات مرافقة",
    "fr": "Applications Compagnons",
    "de": "Begleit-Apps",
    "es": "Aplicaciones de Acompañamiento",
    "ru": "Приложения-помощники",
    "zh": "伴侣应用",
    "ja": "コンパニオンアプリ",
    "ko": "동반 앱",
    "hi": "सहयोगी ऐप्स"
  },
  "pageSub": {
    "id": "Kumpulan aplikasi yang disarankan untuk dipasang agar umrah dan haji di Tanah Suci menjadi lebih mudah dan nyaman — resmi, transportasi, internet, makanan, keuangan.",
    "en": "A collection of recommended apps to install so that your Umrah and Hajj in the Holy Land become easier and more comfortable — official, transportation, internet, food, and finance.",
    "ar": "مجموعة من التطبيقات الموصى بتثبيتها لتسهيل أداء العمرة والحج في الأراضي المقدسة وجعلها أكثر راحة — الرسمية، والمواصلات، والإنترنت، والطعام، والمالية.",
    "fr": "Une collection d'applications recommandées à installer pour rendre votre Umrah et Hajj en Terre Sainte plus faciles et plus confortables — officielles, transport, internet, alimentation et finances.",
    "de": "Eine Sammlung empfohlener Apps, die installiert werden sollten, damit Ihre Umrah und Ihr Hajj im Heiligen Land einfacher und komfortabler werden — offiziell, Transport, Internet, Essen und Finanzen.",
    "es": "Una colección de aplicaciones recomendadas para instalar y hacer que su Umrah y Hajj en la Tierra Santa sean más fáciles y cómodos — oficiales, transporte, internet, alimentación y finanzas.",
    "ru": "Подборка рекомендуемых приложений для установки, чтобы ваши Умра и Хадж на Святой Земле стали проще и комфортнее — официальные, транспортные, интернет, питание и финансы.",
    "zh": "一套推荐安装的应用程序，让您在圣地的副朝与朝觐更加便捷舒适——涵盖官方、交通、网络、餐饮及金融类应用。",
    "ja": "聖地でのウムラとハッジをより簡単で快適にするために、インストールが推奨されるアプリのコレクションです — 公式、交通、インターネット、食事、金融。",
    "ko": "성지에서의 우므라와 하지를 더 쉽고 편안하게 만들기 위해 설치가 권장되는 앱 모음입니다 — 공식, 교통, 인터넷, 음식, 금융.",
    "hi": "पवित्र भूमि में उमराह और हज को आसान और आरामदायक बनाने के लिए अनुशंसित ऐप्स का संग्रह — आधिकारिक, परिवहन, इंटरनेट, भोजन और वित्त।"
  },
  "dashLabel": {
    "id": "Aplikasi Pendamping",
    "en": "Companion Apps",
    "ar": "تطبيقات مرافقة",
    "fr": "Applications Compagnons",
    "de": "Begleit-Apps",
    "es": "Aplicaciones de Acompañamiento",
    "ru": "Приложения-помощники",
    "zh": "伴侣应用",
    "ja": "コンパニオンアプリ",
    "ko": "동반 앱",
    "hi": "सहयोगी ऐप्स"
  },
  "dashHint": {
    "id": "Nusuk, Tawakkalna, HHR Train, Careem & aplikasi penting lainnya",
    "en": "Nusuk, Tawakkalna, HHR Train, Careem & other essential apps",
    "ar": "نُسُك، توكلنا، قطار الحرمين، كريم وغيرها من التطبيقات الأساسية",
    "fr": "Nusuk, Tawakkalna, HHR Train, Careem et autres applications essentielles",
    "de": "Nusuk, Tawakkalna, HHR Train, Careem & andere wichtige Apps",
    "es": "Nusuk, Tawakkalna, HHR Train, Careem y otras aplicaciones esenciales",
    "ru": "Nusuk, Tawakkalna, HHR Train, Careem и другие важные приложения",
    "zh": "Nusuk、Tawakkalna、HHR Train、Careem 及其他重要应用",
    "ja": "Nusuk、Tawakkalna、HHR Train、Careem などの必須アプリ",
    "ko": "Nusuk, Tawakkalna, HHR Train, Careem 및 기타 필수 앱",
    "hi": "Nusuk, Tawakkalna, HHR Train, Careem और अन्य आवश्यक ऐप्स"
  },
  "all": {
    "id": "Semua",
    "en": "All",
    "ar": "الكل",
    "fr": "Tous",
    "de": "Alle",
    "es": "Todos",
    "ru": "Все",
    "zh": "全部",
    "ja": "すべて",
    "ko": "전체",
    "hi": "सभी"
  },
  "essentialOnly": {
    "id": "Hanya wajib punya",
    "en": "Essential only",
    "ar": "الضروري فقط",
    "fr": "Indispensables uniquement",
    "de": "Nur Pflicht-Apps",
    "es": "Solo esenciales",
    "ru": "Только обязательные",
    "zh": "仅必备",
    "ja": "必須のみ",
    "ko": "필수만",
    "hi": "केवल अनिवार्य"
  },
  "essential": {
    "id": "Wajib punya",
    "en": "Must have",
    "ar": "ضروري",
    "fr": "Indispensable",
    "de": "Unverzichtbar",
    "es": "Imprescindible",
    "ru": "Обязательное",
    "zh": "必备",
    "ja": "必須",
    "ko": "필수",
    "hi": "आवश्यक"
  },
  "official": {
    "id": "Resmi",
    "en": "Official",
    "ar": "رسمي",
    "fr": "Officiel",
    "de": "Offiziell",
    "es": "Oficial",
    "ru": "Официальное",
    "zh": "官方",
    "ja": "公式",
    "ko": "공식",
    "hi": "आधिकारिक"
  },
  "free": {
    "id": "Gratis",
    "en": "Free",
    "ar": "مجاني",
    "fr": "Gratuit",
    "de": "Kostenlos",
    "es": "Gratis",
    "ru": "Бесплатно",
    "zh": "免费",
    "ja": "無料",
    "ko": "무료",
    "hi": "निःशुल्क"
  },
  "installed": {
    "id": "Sudah dipasang",
    "en": "Already installed",
    "ar": "مثبَّت بالفعل",
    "fr": "Déjà installé",
    "de": "Bereits installiert",
    "es": "Ya instalado",
    "ru": "Уже установлено",
    "zh": "已安装",
    "ja": "インストール済み",
    "ko": "이미 설치됨",
    "hi": "पहले से इंस्टॉल है"
  },
  "markInstalled": {
    "id": "Tandai sudah dipasang",
    "en": "Mark as installed",
    "ar": "وضع علامة مثبَّت",
    "fr": "Marquer comme installé",
    "de": "Als installiert markieren",
    "es": "Marcar como instalado",
    "ru": "Отметить как установленное",
    "zh": "标记为已安装",
    "ja": "インストール済みとしてマーク",
    "ko": "설치됨으로 표시",
    "hi": "इंस्टॉल किया हुआ चिह्नित करें"
  },
  "unmark": {
    "id": "Batalkan tanda",
    "en": "Unmark",
    "ar": "إلغاء العلامة",
    "fr": "Décocher",
    "de": "Markierung aufheben",
    "es": "Desmarcar",
    "ru": "Снять отметку",
    "zh": "取消标记",
    "ja": "マークを解除",
    "ko": "표시 해제",
    "hi": "चिह्न हटाएं"
  },
  "progress": {
    "id": "{n}/{total} aplikasi sudah dipasang",
    "en": "{n}/{total} apps have been installed",
    "ar": "تم تثبيت {n}/{total} من التطبيقات",
    "fr": "{n}/{total} applications ont été installées",
    "de": "{n}/{total} Apps wurden installiert",
    "es": "{n}/{total} aplicaciones han sido instaladas",
    "ru": "Установлено приложений: {n}/{total}",
    "zh": "已安装 {n}/{total} 个应用",
    "ja": "{n}/{total} 個のアプリがインストールされました",
    "ko": "{n}/{total} 앱이 설치되었습니다",
    "hi": "{n}/{total} ऐप्स इंस्टॉल हो चुके हैं"
  },
  "essentialProgress": {
    "id": "{n}/{total} aplikasi wajib sudah dipasang",
    "en": "{n}/{total} essential apps have been installed",
    "ar": "تم تثبيت {n}/{total} من التطبيقات الأساسية",
    "fr": "{n}/{total} applications essentielles ont été installées",
    "de": "{n}/{total} wichtige Apps wurden installiert",
    "es": "{n}/{total} aplicaciones esenciales han sido instaladas",
    "ru": "Установлено обязательных приложений: {n}/{total}",
    "zh": "已安装 {n}/{total} 个必要应用",
    "ja": "{n}/{total} 個の必須アプリがインストールされました",
    "ko": "{n}/{total} 필수 앱이 설치되었습니다",
    "hi": "{n}/{total} आवश्यक ऐप्स इंस्टॉल हो चुके हैं"
  },
  "allEssentialDone": {
    "id": "Masya Allah! Semua aplikasi wajib sudah terpasang.",
    "en": "Masha Allah! All essential apps have been installed.",
    "ar": "ما شاء الله! تم تثبيت جميع التطبيقات الأساسية.",
    "fr": "Masha Allah ! Toutes les applications essentielles ont été installées.",
    "de": "Mascha Allah! Alle wichtigen Apps wurden installiert.",
    "es": "Masha Allah! Todas las aplicaciones esenciales han sido instaladas.",
    "ru": "Машааллах! Все обязательные приложения установлены.",
    "zh": "马沙安拉！所有必要应用均已安装。",
    "ja": "マーシャーアッラー！すべての必須アプリがインストールされました。",
    "ko": "마샤 알라! 모든 필수 앱이 설치되었습니다.",
    "hi": "माशा अल्लाह! सभी आवश्यक ऐप्स इंस्टॉल हो चुके हैं।"
  },
  "usesTitle": {
    "id": "Berguna untuk",
    "en": "Useful for",
    "ar": "مفيد لـ",
    "fr": "Utile pour",
    "de": "Nützlich für",
    "es": "Útil para",
    "ru": "Полезно для",
    "zh": "适用于",
    "ja": "役立つ用途",
    "ko": "유용한 용도",
    "hi": "उपयोगी है"
  },
  "tipTitle": {
    "id": "Tips",
    "en": "Tips",
    "ar": "نصائح",
    "fr": "Conseils",
    "de": "Tipps",
    "es": "Consejos",
    "ru": "Советы",
    "zh": "提示",
    "ja": "ヒント",
    "ko": "팁",
    "hi": "सुझाव"
  },
  "openPlay": {
    "id": "Google Play",
    "en": "Google Play",
    "ar": "Google Play",
    "fr": "Google Play",
    "de": "Google Play",
    "es": "Google Play",
    "ru": "Google Play",
    "zh": "Google Play",
    "ja": "Google Play",
    "ko": "Google Play",
    "hi": "Google Play"
  },
  "openAppStore": {
    "id": "App Store",
    "en": "App Store",
    "ar": "App Store",
    "fr": "App Store",
    "de": "App Store",
    "es": "App Store",
    "ru": "App Store",
    "zh": "App Store",
    "ja": "App Store",
    "ko": "App Store",
    "hi": "App Store"
  },
  "openWeb": {
    "id": "Situs resmi",
    "en": "Official website",
    "ar": "الموقع الرسمي",
    "fr": "Site officiel",
    "de": "Offizielle Website",
    "es": "Sitio web oficial",
    "ru": "Официальный сайт",
    "zh": "官方网站",
    "ja": "公式サイト",
    "ko": "공식 웹사이트",
    "hi": "आधिकारिक वेबसाइट"
  },
  "searchPlay": {
    "id": "Cari di Google Play",
    "en": "Search on Google Play",
    "ar": "البحث على Google Play",
    "fr": "Rechercher sur Google Play",
    "de": "Bei Google Play suchen",
    "es": "Buscar en Google Play",
    "ru": "Найти в Google Play",
    "zh": "在 Google Play 上搜索",
    "ja": "Google Play で検索",
    "ko": "Google Play에서 검색",
    "hi": "Google Play पर खोजें"
  },
  "searchPlaceholder": {
    "id": "Cari aplikasi (mis. Nusuk, kereta, taksi)…",
    "en": "Search apps (e.g. Nusuk, train, taxi)…",
    "ar": "ابحث عن التطبيقات (مثل: نُسُك، القطار، التاكسي)…",
    "fr": "Rechercher des applications (ex. Nusuk, train, taxi)…",
    "de": "Apps suchen (z. B. Nusuk, Zug, Taxi)…",
    "es": "Buscar aplicaciones (p. ej. Nusuk, tren, taxi)…",
    "ru": "Поиск приложений (напр. Nusuk, поезд, такси)…",
    "zh": "搜索应用（如 Nusuk、火车、出租车）…",
    "ja": "アプリを検索（例：Nusuk、電車、タクシー）…",
    "ko": "앱 검색 (예: Nusuk, 기차, 택시)…",
    "hi": "ऐप खोजें (जैसे Nusuk, ट्रेन, टैक्सी)…"
  },
  "noResults": {
    "id": "Tidak ada aplikasi yang cocok.",
    "en": "No matching apps found.",
    "ar": "لا توجد تطبيقات مطابقة.",
    "fr": "Aucune application correspondante trouvée.",
    "de": "Keine passenden Apps gefunden.",
    "es": "No se encontraron aplicaciones coincidentes.",
    "ru": "Подходящих приложений не найдено.",
    "zh": "未找到匹配的应用。",
    "ja": "一致するアプリが見つかりませんでした。",
    "ko": "일치하는 앱이 없습니다.",
    "hi": "कोई मेल खाने वाला ऐप नहीं मिला।"
  },
  "showing": {
    "id": "{n} aplikasi",
    "en": "{n} apps",
    "ar": "{n} تطبيقات",
    "fr": "{n} applications",
    "de": "{n} Apps",
    "es": "{n} aplicaciones",
    "ru": "{n} приложений",
    "zh": "{n} 个应用",
    "ja": "{n} 件のアプリ",
    "ko": "{n}개의 앱",
    "hi": "{n} ऐप्स"
  },
  "reset": {
    "id": "Atur ulang tanda",
    "en": "Reset markers",
    "ar": "إعادة ضبط العلامات",
    "fr": "Réinitialiser les marqueurs",
    "de": "Markierungen zurücksetzen",
    "es": "Restablecer marcadores",
    "ru": "Сбросить метки",
    "zh": "重置标记",
    "ja": "マーカーをリセット",
    "ko": "마커 초기화",
    "hi": "मार्कर रीसेट करें"
  },
  "shareBtn": {
    "id": "Bagikan daftar",
    "en": "Share list",
    "ar": "مشاركة القائمة",
    "fr": "Partager la liste",
    "de": "Liste teilen",
    "es": "Compartir lista",
    "ru": "Поделиться списком",
    "zh": "分享列表",
    "ja": "リストをシェア",
    "ko": "목록 공유",
    "hi": "सूची साझा करें"
  },
  "shareTitle": {
    "id": "Aplikasi wajib untuk umrah & haji",
    "en": "Essential apps for Umrah & Hajj",
    "ar": "التطبيقات الضرورية للعمرة والحج",
    "fr": "Applications indispensables pour la Omra & le Hajj",
    "de": "Unverzichtbare Apps für Umrah & Hajj",
    "es": "Aplicaciones esenciales para la Umrah y el Hayy",
    "ru": "Необходимые приложения для умры и хаджа",
    "zh": "朝觐与副朝必备应用",
    "ja": "ウムラ＆ハッジに欠かせないアプリ",
    "ko": "우므라 & 하지 필수 앱",
    "hi": "उमरा और हज के लिए आवश्यक ऐप्स"
  },
  "shareFooter": {
    "id": "Daftar lengkap & panduan: {url}",
    "en": "Full list & guide: {url}",
    "ar": "القائمة الكاملة والدليل: {url}",
    "fr": "Liste complète & guide : {url}",
    "de": "Vollständige Liste & Leitfaden: {url}",
    "es": "Lista completa y guía: {url}",
    "ru": "Полный список и руководство: {url}",
    "zh": "完整列表与指南：{url}",
    "ja": "完全なリストとガイド：{url}",
    "ko": "전체 목록 및 안내: {url}",
    "hi": "पूरी सूची और मार्गदर्शिका: {url}"
  },
  "copied": {
    "id": "Daftar disalin ke papan klip.",
    "en": "List copied to clipboard.",
    "ar": "تم نسخ القائمة إلى الحافظة.",
    "fr": "Liste copiée dans le presse-papiers.",
    "de": "Liste in die Zwischenablage kopiert.",
    "es": "Lista copiada al portapapeles.",
    "ru": "Список скопирован в буфер обмена.",
    "zh": "列表已复制到剪贴板。",
    "ja": "リストをクリップボードにコピーしました。",
    "ko": "목록이 클립보드에 복사되었습니다.",
    "hi": "सूची क्लिपबोर्ड पर कॉपी की गई।"
  },
  "builtInTitle": {
    "id": "Sudah tersedia di Manasik Guide",
    "en": "Already available in Manasik Guide",
    "ar": "متوفر بالفعل في Manasik Guide",
    "fr": "Déjà disponible dans Manasik Guide",
    "de": "Bereits in Manasik Guide verfügbar",
    "es": "Ya disponible en Manasik Guide",
    "ru": "Уже доступно в Manasik Guide",
    "zh": "已内置于 Manasik Guide",
    "ja": "Manasik Guide にすでに搭載されています",
    "ko": "Manasik Guide에 이미 포함되어 있습니다",
    "hi": "Manasik Guide में पहले से उपलब्ध है"
  },
  "builtInHint": {
    "id": "Tidak perlu aplikasi tambahan untuk: jadwal salat & adzan, kompas kiblat, peta Masjidil Haram & Nabawi, Al-Qur'an & murottal, doa manasik, checklist, pengingat, dan panduan kesehatan.",
    "en": "No additional apps needed for: prayer schedule & adhan, Qibla compass, maps of Masjid al-Haram & Masjid al-Nabawi, Qur'an & murattal, manasik supplications, checklist, reminders, and health guidance.",
    "ar": "لا حاجة إلى تطبيقات إضافية لـ: جداول الصلاة والأذان، بوصلة القبلة، خرائط المسجد الحرام والمسجد النبوي، القرآن الكريم والمرتّل، أدعية المناسك، قائمة المهام، التذكيرات، والإرشادات الصحية.",
    "fr": "Aucune application supplémentaire n'est nécessaire pour : l'horaire des prières & l'adhan, la boussole Qibla, les cartes de la Masjid al-Haram & de la Masjid al-Nabawi, le Coran & le murattal, les invocations du manasik, la liste de contrôle, les rappels et les conseils de santé.",
    "de": "Keine zusätzlichen Apps erforderlich für: Gebetszeiten & Adhan, Qibla-Kompass, Karten der Masjid al-Haram & Masjid al-Nabawi, Qur'an & Murattal, Manasik-Bittgebete, Checkliste, Erinnerungen und Gesundheitsratschläge.",
    "es": "No se necesitan aplicaciones adicionales para: horario de oraciones y adhan, brújula de Qibla, mapas de la Masjid al-Haram y la Masjid al-Nabawi, Corán y murattal, súplicas del manasik, lista de verificación, recordatorios y orientación de salud.",
    "ru": "Дополнительные приложения не нужны для: расписания молитв и азана, компаса Киблы, карт Масджид аль-Харам и Масджид ан-Набави, Корана и муратталя, ду'а манасик, контрольного списка, напоминаний и советов по здоровью.",
    "zh": "无需额外应用即可使用：礼拜时间表与宣礼（Adhan）、朝向麦加（Qibla）指南针、麦地圣寺（Masjid al-Haram）与先知清真寺（Masjid al-Nabawi）地图、《古兰经》与诵读（Murattal）、朝觐（Manasik）祈祷、清单、提醒及健康指南。",
    "ja": "礼拝スケジュール＆アザーン、キブラコンパス、マスジド・アル・ハラムとマスジド・アン・ナバウィの地図、クルアーン＆ムラッタル、マナシク（礼拝儀礼）のドゥアー、チェックリスト、リマインダー、健康ガイダンスに追加アプリは不要です。",
    "ko": "예배 일정 및 아잔, 키블라 나침반, 마스지드 알-하람 및 마스지드 안-나바위 지도, 꾸란 및 무라탈, 마나시크 두아, 체크리스트, 알림, 건강 안내를 위한 추가 앱이 필요하지 않습니다.",
    "hi": "नमाज़ का समय-सारणी और अज़ान, क़िबला कम्पास, मस्जिद अल-हरम और मस्जिद अन-नबवी के नक्शे, क़ुरआन और मुरत्तल, मनासिक की दुआएं, चेकलिस्ट, रिमाइंडर और स्वास्थ्य मार्गदर्शन के लिए किसी अतिरिक्त ऐप की ज़रूरत नहीं है।"
  },
  "emergencyTitle": {
    "id": "Nomor penting di Arab Saudi",
    "en": "Important Numbers in Saudi Arabia",
    "ar": "الأرقام المهمة في المملكة العربية السعودية",
    "fr": "Numéros importants en Arabie Saoudite",
    "de": "Wichtige Rufnummern in Saudi-Arabien",
    "es": "Números importantes en Arabia Saudita",
    "ru": "Важные номера в Саудовской Аравии",
    "zh": "沙特阿拉伯重要电话号码",
    "ja": "サウジアラビアの重要な連絡先番号",
    "ko": "사우디아라비아 중요 전화번호",
    "hi": "सऊदी अरब में महत्वपूर्ण नंबर"
  },
  "emergencyHint": {
    "id": "Ketuk nomor untuk menelepon. Simpan juga nomor hotel, pembimbing, dan KJRI Jeddah / KBRI Riyadh.",
    "en": "Tap a number to call. Also save your hotel number, guide's number, and the Indonesian Consulate General in Jeddah / Indonesian Embassy in Riyadh.",
    "ar": "اضغط على الرقم للاتصال. احفظ أيضاً رقم الفندق، ورقم المرشد، والقنصلية العامة الإندونيسية في جدة / السفارة الإندونيسية في الرياض.",
    "fr": "Appuyez sur un numéro pour appeler. Enregistrez également le numéro de votre hôtel, de votre guide et du Consulat Général d'Indonésie à Jeddah / de l'Ambassade d'Indonésie à Riyad.",
    "de": "Tippen Sie auf eine Nummer, um anzurufen. Speichern Sie auch die Nummer Ihres Hotels, Ihres Reiseleiters sowie des indonesischen Generalkonsulats in Jeddah / der indonesischen Botschaft in Riad.",
    "es": "Toque un número para llamar. Guarde también el número de su hotel, de su guía y del Consulado General de Indonesia en Jeddah / la Embajada de Indonesia en Riad.",
    "ru": "Нажмите на номер, чтобы позвонить. Также сохраните номер вашего отеля, гида и Генерального консульства Индонезии в Джидде / Посольства Индонезии в Эр-Рияде.",
    "zh": "点击号码即可拨打电话。同时请保存您酒店的号码、导游的号码以及印度尼西亚驻吉达总领事馆/印度尼西亚驻利雅得大使馆的号码。",
    "ja": "番号をタップして電話をかけてください。ホテルの番号、ガイドの番号、およびジェッダのインドネシア総領事館／リヤドのインドネシア大使館の番号も保存してください。",
    "ko": "번호를 눌러 전화하세요. 호텔 번호, 가이드 번호, 제다 인도네시아 총영사관 / 리야드 인도네시아 대사관 번호도 저장해 두세요.",
    "hi": "कॉल करने के लिए नंबर पर टैप करें। अपने होटल का नंबर, गाइड का नंबर और जेद्दा में इंडोनेशियाई महावाणिज्य दूतावास / रियाद में इंडोनेशियाई दूतावास का नंबर भी सेव करें।"
  },
  "call": {
    "id": "Telepon",
    "en": "Call",
    "ar": "اتصال",
    "fr": "Appeler",
    "de": "Anrufen",
    "es": "Llamar",
    "ru": "Позвонить",
    "zh": "拨打电话",
    "ja": "電話をかける",
    "ko": "전화하기",
    "hi": "कॉल करें"
  },
  "disclaimer": {
    "id": "Nama dan merek aplikasi adalah milik masing-masing pengembang. Pasang hanya dari Google Play / App Store resmi, periksa nama pengembang, dan jangan pernah membagikan kode OTP kepada siapa pun. Ketersediaan fitur dapat berubah sewaktu-waktu.",
    "en": "App names and brands are the property of their respective developers. Install only from the official Google Play / App Store, verify the developer's name, and never share your OTP code with anyone. Feature availability may change at any time.",
    "ar": "أسماء التطبيقات والعلامات التجارية هي ملك لمطوريها المعنيين. ثبِّت التطبيقات من متجر Google Play / App Store الرسمي فقط، وتحقق من اسم المطوِّر، ولا تشارك رمز OTP مع أي أحد. قد تتغير توفر الميزات في أي وقت.",
    "fr": "Les noms et marques des applications appartiennent à leurs développeurs respectifs. Installez uniquement depuis le Google Play / App Store officiel, vérifiez le nom du développeur et ne partagez jamais votre code OTP avec qui que ce soit. La disponibilité des fonctionnalités peut changer à tout moment.",
    "de": "App-Namen und Marken sind Eigentum ihrer jeweiligen Entwickler. Installieren Sie Apps nur aus dem offiziellen Google Play / App Store, überprüfen Sie den Namen des Entwicklers und geben Sie Ihren OTP-Code niemals an Dritte weiter. Die Verfügbarkeit von Funktionen kann sich jederzeit ändern.",
    "es": "Los nombres y marcas de las aplicaciones son propiedad de sus respectivos desarrolladores. Instale únicamente desde Google Play / App Store oficial, verifique el nombre del desarrollador y nunca comparta su código OTP con nadie. La disponibilidad de funciones puede cambiar en cualquier momento.",
    "ru": "Названия и торговые марки приложений являются собственностью их соответствующих разработчиков. Устанавливайте приложения только из официального Google Play / App Store, проверяйте имя разработчика и никогда не сообщайте никому свой OTP-код. Наличие функций может измениться в любое время.",
    "zh": "应用程序的名称和品牌归各自开发者所有。请仅从官方Google Play / App Store安装，核实开发者名称，切勿向任何人分享OTP验证码。功能的可用性可能随时更改。",
    "ja": "アプリ名およびブランドは各開発者の所有物です。公式のGoogle Play / App Storeからのみインストールし、開発者名を確認して、OTPコードを決して誰にも共有しないでください。機能の提供状況はいつでも変更される場合があります。",
    "ko": "앱 이름과 브랜드는 각 개발자의 소유입니다. 공식 Google Play / App Store에서만 설치하고, 개발자 이름을 확인하며, OTP 코드를 절대 누구에게도 공유하지 마세요. 기능 제공 여부는 언제든지 변경될 수 있습니다.",
    "hi": "ऐप के नाम और ब्रांड उनके संबंधित डेवलपर्स की संपत्ति हैं। केवल आधिकारिक Google Play / App Store से ही इंस्टॉल करें, डेवलपर का नाम जांचें और अपना OTP कोड किसी के साथ भी साझा न करें। सुविधाओं की उपलब्धता किसी भी समय बदल सकती है।"
  },
  "fromMandiri": {
    "id": "Lihat daftar aplikasi lengkap beserta tautan unduhnya",
    "en": "View the complete list of apps along with their download links",
    "ar": "اعرض القائمة الكاملة للتطبيقات مع روابط تنزيلها",
    "fr": "Voir la liste complète des applications avec leurs liens de téléchargement",
    "de": "Vollständige App-Liste mit Download-Links anzeigen",
    "es": "Ver la lista completa de aplicaciones con sus enlaces de descarga",
    "ru": "Просмотреть полный список приложений с ссылками для скачивания",
    "zh": "查看完整应用列表及其下载链接",
    "ja": "ダウンロードリンク付きの完全なアプリ一覧を表示する",
    "ko": "다운로드 링크가 포함된 전체 앱 목록 보기",
    "hi": "डाउनलोड लिंक सहित ऐप्स की पूरी सूची देखें"
  },
  "platformNote": {
    "id": "Tautan membuka toko aplikasi resmi di ponsel Anda.",
    "en": "The link opens the official app store on your phone.",
    "ar": "يفتح الرابط متجر التطبيقات الرسمي على هاتفك.",
    "fr": "Le lien ouvre la boutique d'applications officielle sur votre téléphone.",
    "de": "Der Link öffnet den offiziellen App-Store auf Ihrem Telefon.",
    "es": "El enlace abre la tienda de aplicaciones oficial en su teléfono.",
    "ru": "Ссылка открывает официальный магазин приложений на вашем телефоне.",
    "zh": "该链接将在您的手机上打开官方应用商店。",
    "ja": "リンクをタップすると、お使いの携帯電話の公式アプリストアが開きます。",
    "ko": "링크를 누르면 휴대폰의 공식 앱 스토어가 열립니다.",
    "hi": "यह लिंक आपके फ़ोन पर आधिकारिक ऐप स्टोर खोलता है।"
  },
  "contactsTitle": {
    "id": "Kontak Darurat Pribadi",
    "en": "Personal Emergency Contacts",
    "ar": "جهات الاتصال الشخصية للطوارئ",
    "fr": "Contacts d'urgence personnels",
    "de": "Persönliche Notfallkontakte",
    "es": "Contactos de emergencia personales",
    "ru": "Личные экстренные контакты",
    "zh": "个人紧急联系人",
    "ja": "個人緊急連絡先",
    "ko": "개인 긴급 연락처",
    "hi": "व्यक्तिगत आपातकालीन संपर्क"
  },
  "contactsHint": {
    "id": "Simpan nomor hotel, pembimbing, dan perwakilan RI — sekali ketuk langsung menelepon. Tersimpan di akun Anda dan ikut di semua perangkat.",
    "en": "Save your hotel, guide, and Indonesian Representative Office numbers — one tap to call directly. Stored in your account and synced across all your devices.",
    "ar": "احفظ أرقام الفندق والمرشد والممثلية الإندونيسية — اضغط مرة واحدة للاتصال مباشرة. تُحفظ في حسابك وتتزامن على جميع أجهزتك.",
    "fr": "Enregistrez les numéros de votre hôtel, de votre guide et de la représentation indonésienne — un seul appui pour appeler directement. Sauvegardés dans votre compte et synchronisés sur tous vos appareils.",
    "de": "Speichern Sie die Nummern Ihres Hotels, Reiseleiters und der indonesischen Vertretung – mit einem Tipp direkt anrufen. In Ihrem Konto gespeichert und auf allen Geräten synchronisiert.",
    "es": "Guarda los números de tu hotel, guía y Representación de Indonesia — un toque para llamar directamente. Almacenados en tu cuenta y sincronizados en todos tus dispositivos.",
    "ru": "Сохраните номера вашего отеля, гида и представительства Индонезии — один нажим для прямого звонка. Хранятся в вашем аккаунте и синхронизируются на всех устройствах.",
    "zh": "保存您的酒店、导游及印度尼西亚代表处的电话号码——一键直接拨打。存储在您的账户中，并在所有设备上同步。",
    "ja": "ホテル、ガイド、インドネシア代表部の電話番号を保存しましょう — ワンタップで直接電話できます。アカウントに保存され、すべてのデバイスで同期されます。",
    "ko": "호텔, 가이드, 인도네시아 대표부 번호를 저장하세요 — 한 번의 탭으로 바로 전화할 수 있습니다. 계정에 저장되어 모든 기기에서 동기화됩니다.",
    "hi": "अपने होटल, गाइड और इंडोनेशियाई प्रतिनिधि कार्यालय के नंबर सहेजें — एक टैप में सीधे कॉल करें। आपके खाते में सुरक्षित और सभी डिवाइस पर समन्वित।"
  },
  "contactsFilled": {
    "id": "{n}/{total} kontak terisi",
    "en": "{n}/{total} contacts filled",
    "ar": "{n}/{total} جهة اتصال مكتملة",
    "fr": "{n}/{total} contacts remplis",
    "de": "{n}/{total} Kontakte ausgefüllt",
    "es": "{n}/{total} contactos completados",
    "ru": "{n}/{total} контактов заполнено",
    "zh": "已填写 {n}/{total} 个联系人",
    "ja": "{n}/{total} 件の連絡先が入力済み",
    "ko": "{n}/{total} 연락처 작성됨",
    "hi": "{n}/{total} संपर्क भरे गए"
  },
  "addContact": {
    "id": "Tambah kontak",
    "en": "Add contact",
    "ar": "إضافة جهة اتصال",
    "fr": "Ajouter un contact",
    "de": "Kontakt hinzufügen",
    "es": "Agregar contacto",
    "ru": "Добавить контакт",
    "zh": "添加联系人",
    "ja": "連絡先を追加",
    "ko": "연락처 추가",
    "hi": "संपर्क जोड़ें"
  },
  "editContact": {
    "id": "Ubah kontak",
    "en": "Edit contact",
    "ar": "تعديل جهة الاتصال",
    "fr": "Modifier le contact",
    "de": "Kontakt bearbeiten",
    "es": "Editar contacto",
    "ru": "Редактировать контакт",
    "zh": "编辑联系人",
    "ja": "連絡先を編集",
    "ko": "연락처 편집",
    "hi": "संपर्क संपादित करें"
  },
  "newContact": {
    "id": "Kontak baru",
    "en": "New contact",
    "ar": "جهة اتصال جديدة",
    "fr": "Nouveau contact",
    "de": "Neuer Kontakt",
    "es": "Nuevo contacto",
    "ru": "Новый контакт",
    "zh": "新建联系人",
    "ja": "新しい連絡先",
    "ko": "새 연락처",
    "hi": "नया संपर्क"
  },
  "contactLabel": {
    "id": "Nama kontak",
    "en": "Contact name",
    "ar": "اسم جهة الاتصال",
    "fr": "Nom du contact",
    "de": "Kontaktname",
    "es": "Nombre del contacto",
    "ru": "Имя контакта",
    "zh": "联系人姓名",
    "ja": "連絡先名",
    "ko": "연락처 이름",
    "hi": "संपर्क का नाम"
  },
  "contactLabelPlaceholder": {
    "id": "mis. Dokter kloter, teman sekamar",
    "en": "e.g. Group doctor, roommate",
    "ar": "مثال: طبيب المجموعة، رفيق الغرفة",
    "fr": "ex. Médecin du groupe, colocataire",
    "de": "z. B. Gruppenarzt, Mitbewohner",
    "es": "p. ej. Médico del grupo, compañero de habitación",
    "ru": "напр. Врач группы, сосед по комнате",
    "zh": "例如：团队医生、室友",
    "ja": "例：グループ担当医、ルームメイト",
    "ko": "예: 그룹 의사, 룸메이트",
    "hi": "जैसे: समूह चिकित्सक, रूममेट"
  },
  "contactPhone": {
    "id": "Nomor telepon",
    "en": "Phone Number",
    "ar": "رقم الهاتف",
    "fr": "Numéro de téléphone",
    "de": "Telefonnummer",
    "es": "Número de teléfono",
    "ru": "Номер телефона",
    "zh": "电话号码",
    "ja": "電話番号",
    "ko": "전화번호",
    "hi": "फ़ोन नंबर"
  },
  "contactPhoneHint": {
    "id": "Gunakan kode negara, mis. +966 5xx xxx xxx (Saudi) atau +62 8xx (Indonesia).",
    "en": "Use country code, e.g. +966 5xx xxx xxx (Saudi Arabia) or +62 8xx (Indonesia).",
    "ar": "استخدم رمز الدولة، مثلاً +966 5xx xxx xxx (السعودية) أو +62 8xx (إندونيسيا).",
    "fr": "Utilisez le code pays, ex. +966 5xx xxx xxx (Arabie Saoudite) ou +62 8xx (Indonésie).",
    "de": "Ländervorwahl verwenden, z. B. +966 5xx xxx xxx (Saudi-Arabien) oder +62 8xx (Indonesien).",
    "es": "Use el código de país, p. ej. +966 5xx xxx xxx (Arabia Saudita) o +62 8xx (Indonesia).",
    "ru": "Используйте код страны, напр. +966 5xx xxx xxx (Саудовская Аравия) или +62 8xx (Индонезия).",
    "zh": "请使用国家代码，例如 +966 5xx xxx xxx（沙特阿拉伯）或 +62 8xx（印度尼西亚）。",
    "ja": "国番号を使用してください。例：+966 5xx xxx xxx（サウジアラビア）または +62 8xx（インドネシア）。",
    "ko": "국가 코드를 사용하세요. 예: +966 5xx xxx xxx (사우디아라비아) 또는 +62 8xx (인도네시아).",
    "hi": "देश कोड का उपयोग करें, जैसे +966 5xx xxx xxx (सऊदी अरब) या +62 8xx (इंडोनेशिया)।"
  },
  "contactNote": {
    "id": "Catatan",
    "en": "Note",
    "ar": "ملاحظة",
    "fr": "Note",
    "de": "Notiz",
    "es": "Nota",
    "ru": "Заметка",
    "zh": "备注",
    "ja": "メモ",
    "ko": "메모",
    "hi": "नोट"
  },
  "contactNotePlaceholder": {
    "id": "mis. nama hotel, nomor kamar, lantai",
    "en": "e.g. hotel name, room number, floor",
    "ar": "مثلاً اسم الفندق، رقم الغرفة، الطابق",
    "fr": "ex. nom de l'hôtel, numéro de chambre, étage",
    "de": "z. B. Hotelname, Zimmernummer, Etage",
    "es": "p. ej. nombre del hotel, número de habitación, piso",
    "ru": "напр. название отеля, номер комнаты, этаж",
    "zh": "例如：酒店名称、房间号、楼层",
    "ja": "例：ホテル名、部屋番号、フロア",
    "ko": "예: 호텔 이름, 객실 번호, 층",
    "hi": "जैसे होटल का नाम, कमरा नंबर, मंज़िल"
  },
  "save": {
    "id": "Simpan",
    "en": "Save",
    "ar": "حفظ",
    "fr": "Enregistrer",
    "de": "Speichern",
    "es": "Guardar",
    "ru": "Сохранить",
    "zh": "保存",
    "ja": "保存",
    "ko": "저장",
    "hi": "सहेजें"
  },
  "delete": {
    "id": "Hapus",
    "en": "Delete",
    "ar": "حذف",
    "fr": "Supprimer",
    "de": "Löschen",
    "es": "Eliminar",
    "ru": "Удалить",
    "zh": "删除",
    "ja": "削除",
    "ko": "삭제",
    "hi": "हटाएं"
  },
  "cancel": {
    "id": "Batal",
    "en": "Cancel",
    "ar": "إلغاء",
    "fr": "Annuler",
    "de": "Abbrechen",
    "es": "Cancelar",
    "ru": "Отмена",
    "zh": "取消",
    "ja": "キャンセル",
    "ko": "취소",
    "hi": "रद्द करें"
  },
  "notSet": {
    "id": "Belum diisi — ketuk untuk mengisi",
    "en": "Not filled in — tap to fill",
    "ar": "لم يُملأ بعد — اضغط للملء",
    "fr": "Non renseigné — appuyez pour remplir",
    "de": "Nicht ausgefüllt — tippen zum Ausfüllen",
    "es": "No completado — toca para rellenar",
    "ru": "Не заполнено — нажмите, чтобы заполнить",
    "zh": "尚未填写 — 点击以填写",
    "ja": "未入力 — タップして入力",
    "ko": "미입력 — 탭하여 입력",
    "hi": "भरा नहीं गया — भरने के लिए टैप करें"
  },
  "whatsapp": {
    "id": "WhatsApp",
    "en": "WhatsApp",
    "ar": "واتساب",
    "fr": "WhatsApp",
    "de": "WhatsApp",
    "es": "WhatsApp",
    "ru": "WhatsApp",
    "zh": "WhatsApp",
    "ja": "WhatsApp",
    "ko": "WhatsApp",
    "hi": "WhatsApp"
  },
  "edit": {
    "id": "Ubah",
    "en": "Edit",
    "ar": "تعديل",
    "fr": "Modifier",
    "de": "Bearbeiten",
    "es": "Editar",
    "ru": "Изменить",
    "zh": "编辑",
    "ja": "編集",
    "ko": "편집",
    "hi": "संपादित करें"
  },
  "officialDefault": {
    "id": "Nomor resmi (sumber: Kemlu RI) — periksa kembali sebelum berangkat.",
    "en": "Official number (source: Indonesian Ministry of Foreign Affairs) — please verify before departure.",
    "ar": "الرقم الرسمي (المصدر: وزارة الخارجية الإندونيسية) — يُرجى التحقق منه قبل المغادرة.",
    "fr": "Numéro officiel (source : ministère indonésien des Affaires étrangères) — vérifiez avant le départ.",
    "de": "Offizielle Nummer (Quelle: indonesisches Außenministerium) — bitte vor der Abreise überprüfen.",
    "es": "Número oficial (fuente: Ministerio de Relaciones Exteriores de Indonesia) — verifique antes de partir.",
    "ru": "Официальный номер (источник: Министерство иностранных дел Индонезии) — проверьте перед отъездом.",
    "zh": "官方号码（来源：印度尼西亚外交部）— 请在出发前核实。",
    "ja": "公式番号（出典：インドネシア外務省）— 出発前にご確認ください。",
    "ko": "공식 번호 (출처: 인도네시아 외교부) — 출발 전에 반드시 확인하세요.",
    "hi": "आधिकारिक नंबर (स्रोत: इंडोनेशिया का विदेश मंत्रालय) — प्रस्थान से पहले जाँच लें।"
  },
  "restoreDefault": {
    "id": "Kembalikan nomor resmi",
    "en": "Restore official number",
    "ar": "استعادة الرقم الرسمي",
    "fr": "Restaurer le numéro officiel",
    "de": "Offizielle Nummer wiederherstellen",
    "es": "Restaurar el número oficial",
    "ru": "Восстановить официальный номер",
    "zh": "恢复官方号码",
    "ja": "公式番号に戻す",
    "ko": "공식 번호 복원",
    "hi": "आधिकारिक नंबर पुनर्स्थापित करें"
  },
  "contactSaved": {
    "id": "Kontak disimpan.",
    "en": "Contact saved.",
    "ar": "تم حفظ جهة الاتصال.",
    "fr": "Contact enregistré.",
    "de": "Kontakt gespeichert.",
    "es": "Contacto guardado.",
    "ru": "Контакт сохранён.",
    "zh": "联系人已保存。",
    "ja": "連絡先を保存しました。",
    "ko": "연락처가 저장되었습니다.",
    "hi": "संपर्क सहेजा गया।"
  },
  "contactDeleted": {
    "id": "Kontak dihapus.",
    "en": "Contact deleted.",
    "ar": "تم حذف جهة الاتصال.",
    "fr": "Contact supprimé.",
    "de": "Kontakt gelöscht.",
    "es": "Contacto eliminado.",
    "ru": "Контакт удалён.",
    "zh": "联系人已删除。",
    "ja": "連絡先を削除しました。",
    "ko": "연락처가 삭제되었습니다.",
    "hi": "संपर्क हटा दिया गया।"
  },
  "invalidPhone": {
    "id": "Nomor telepon tidak valid. Gunakan angka dengan kode negara, mis. +966…",
    "en": "Invalid phone number. Use digits with a country code, e.g. +966…",
    "ar": "رقم الهاتف غير صالح. استخدم الأرقام مع رمز الدولة، مثل: ‎+966…",
    "fr": "Numéro de téléphone invalide. Utilisez des chiffres avec l'indicatif pays, ex. +966…",
    "de": "Ungültige Telefonnummer. Verwenden Sie Ziffern mit Ländervorwahl, z. B. +966…",
    "es": "Número de teléfono inválido. Use dígitos con el código de país, p. ej. +966…",
    "ru": "Неверный номер телефона. Используйте цифры с кодом страны, напр. +966…",
    "zh": "电话号码无效。请使用带国家代码的数字，例如 +966…",
    "ja": "無効な電話番号です。国番号付きの数字を使用してください。例：+966…",
    "ko": "유효하지 않은 전화번호입니다. 국가 코드를 포함한 숫자를 사용하세요. 예: +966…",
    "hi": "अमान्य फ़ोन नंबर। देश कोड सहित अंकों का उपयोग करें, जैसे +966…"
  },
  "labelRequired": {
    "id": "Nama kontak wajib diisi.",
    "en": "Contact name is required.",
    "ar": "اسم جهة الاتصال مطلوب.",
    "fr": "Le nom du contact est obligatoire.",
    "de": "Kontaktname ist erforderlich.",
    "es": "El nombre del contacto es obligatorio.",
    "ru": "Имя контакта обязательно для заполнения.",
    "zh": "联系人姓名为必填项。",
    "ja": "連絡先の名前は必須です。",
    "ko": "연락처 이름은 필수입니다.",
    "hi": "संपर्क का नाम आवश्यक है।"
  }
};
